import { tv } from "tailwind-variants";

/** Legacy select styling retained for the audio player's bespoke selects.
 *  New code should compose {@link SimpleSelect} / {@link MultiSelect}
 *  (and {@link MultiSelectPopover}) instead. */
export const legacySelectStyle = tv({
  slots: {
    button:
      "min-h-[36px] w-full min-w-[100px] cursor-default rounded-md bg-white py-1.5 text-left text-sm text-foreground shadow-xs ring-1 ring-border-strong ring-inset focus:ring-2 focus:ring-indigo-600 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 sm:leading-6",
    placeholder: "text-gray-400",
    chevron: "size-5 shrink-0 text-gray-400",
    popover:
      "max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm",
  },
});
